module.exports = __webpack_public_path__ + "img/h-page4-54.c245e585.png";